export const TEXT_CASE = {
  NONE: 'none',
  UPPER: 'upper',
  LOWER: 'lower',
  CAPITALIZE: 'capitalize'
};

export const TEXT_CASE_VALUE = {
  [TEXT_CASE.UPPER]: 'uppercase',
  [TEXT_CASE.LOWER]: 'lowercase',
  [TEXT_CASE.CAPITALIZE]: 'capitalize'
};
